import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';
import { ADDENDUM_IN_PROGRESS } from '../../../../../constants/reports';
import { formatDate } from '../../../../../utils/formatters';

const PNFuneralTrustAgingDetailedRow = ({ rowData, id, nestedColumnsNumber, slNo }) => {
  const { purchaserName, onePortalId, service } = rowData;

  return (
    <tr key={id} className="table-body-tr">
      <td width="50px" align="center" className="valign-middle">
        {slNo}
      </td>
      <td className="valign-middle">
        <div className="mb-1 display-block">{purchaserName}</div>
        <div className="unit-no">{onePortalId}</div>
      </td>
      {[...Array(nestedColumnsNumber)].map((_col, column) => {
        return (
          <td key={column} className="p-0 tb-next td-next-1 tr-next">
            {service?.map((serviceType, stIndex) => {
              return (
                <table key={stIndex} className="inner-table pn-aging-inner-table">
                  <tbody>
                    {serviceType.serviceDetails.map((rowDataValues, subIndex) => {
                      const aip = rowDataValues?.addendumStatus === ADDENDUM_IN_PROGRESS;
                      let tdClass = 'pn-aging-td-normal';
                      if (column === 0 && subIndex === 0 && aip) {
                        tdClass = 'pn-aging-td-first-add-in-progress-fixed';
                      } else if (column === 0 && subIndex === 0 && !aip) {
                        tdClass = 'pn-aging-td-first-no-addendum-fixed';
                      } else if (column === 0 && subIndex !== 0 && aip) {
                        tdClass = 'pn-aging-td-addendum-fixed';
                      } else if (column !== 0 && subIndex === 0 && aip) {
                        tdClass = 'pn-aging-td-first-add-in-progress-fixed';
                      } else if (column !== 0 && subIndex === 0 && !aip) {
                        tdClass = 'pn-aging-td-first-no-addendum-fixed';
                      } else if (column !== 0 && subIndex !== 0 && aip) {
                        tdClass = 'pn-aging-td-addendum-fixed';
                      }
                      return (
                        <>
                          {column === 0 && (
                            <tr>
                              <td className={`detail-td ${tdClass}`}>
                                {subIndex === 0 && (
                                  <div className="mb-1 display-block detail-div">
                                    {`${serviceType?.serviceType} (${serviceType?.toatlNoService})`}
                                  </div>
                                )}
                                <span className="unit-no">
                                  {rowDataValues?.serviceNumber || ' '}
                                </span>
                                {rowDataValues?.addendumStatus === ADDENDUM_IN_PROGRESS && (
                                  <span className="addendum-note">Note: Addendum In Progress</span>
                                )}
                              </td>
                            </tr>
                          )}
                          {column === 1 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{formatDate(rowDataValues?.contractDate)}</td>
                            </tr>
                          )}
                          {column === 2 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.totalAmount)}</td>
                            </tr>
                          )}
                          {column === 3 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.downPayment)}</td>
                            </tr>
                          )}
                          {column === 4 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.monthlyPayment)}</td>
                            </tr>
                          )}
                          {column === 5 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.unDue)}</td>
                            </tr>
                          )}
                          {column === 6 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.overDue)}</td>
                            </tr>
                          )}
                          {column === 7 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.day30)}</td>
                            </tr>
                          )}
                          {column === 8 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.day60)}</td>
                            </tr>
                          )}
                          {column === 9 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.day90)}</td>
                            </tr>
                          )}
                          {column === 10 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.day120)}</td>
                            </tr>
                          )}
                          {column === 11 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.day640)}</td>
                            </tr>
                          )}
                          {column === 12 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.day670)}</td>
                            </tr>
                          )}
                          {column === 13 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.day700)}</td>
                            </tr>
                          )}
                          {column === 14 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.day730)}</td>
                            </tr>
                          )}
                          {column === 15 && (
                            <tr className="tr-next">
                              <td className={tdClass}>{getPrice(rowDataValues?.above730)}</td>
                            </tr>
                          )}
                        </>
                      );
                    })}
                  </tbody>
                </table>
              );
            })}
          </td>
        );
      })}
    </tr>
  );
};

PNFuneralTrustAgingDetailedRow.propTypes = {
  rowData: PropTypes.shape({
    purchaserName: PropTypes.string,
    onePortalId: PropTypes.string,
    service: PropTypes.shape([
      {
        serviceType: PropTypes.string,
        toatlNoService: PropTypes.number,
        serviceDetails: PropTypes.shape([
          {
            serviceNumber: PropTypes.string,
            contractDate: PropTypes.string,
            totalAmount: PropTypes.number,
            downPayment: PropTypes.number,
            monthlyPayment: PropTypes.number,
            unDue: PropTypes.number,
            overDue: PropTypes.number,
            day640: PropTypes.number,
            day670: PropTypes.number,
            day700: PropTypes.number,
            day730: PropTypes.number,
            above730: PropTypes.number,
          },
        ]),
      },
    ]),
  }).isRequired,
  id: PropTypes.number.isRequired,
  nestedColumnsNumber: PropTypes.number.isRequired,
  slNo: PropTypes.number.isRequired,
};

export default PNFuneralTrustAgingDetailedRow;
